module.exports = __webpack_public_path__ + "static/media/rampage.73fd16ff.png";